import { RiskLevel } from "@/model/RiskLevel";
import LewishamLogo from "@/assets/regions/lewisham-logo.svg";
const HighRisk = {
    rawCopy: "For alcohol advice and support, call Humankind PCRS on 02086995263 or find out more <u>here</u>",
    logoLink: "https://humankindcharity.org.uk/service/primary-care-recovery-service-pcrs"
};
const LowerRisk = {
    rawCopy: "Keep up the good work with the help of <u>the free DrinkCoach app!</u>",
    logoLink: "https://drinkcoach.org.uk/download-drinkcoach-app"
};
const IncreasingRisk = {
    rawCopy: `For Increasing Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online appointment</u> with an alcohol specialist.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/16"
};
const HigherRisk = {
    rawCopy: `For Higher Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online appointment</u> with an alcohol specialist.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/16"
};
export default {
    name: "Lewisham",
    logo: {
        file: LewishamLogo,
        width: 200,
        height: 31
    },
    hasFreeAppointments: true,
    zoomLevel: 13,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: HighRisk,
        [RiskLevel.Lower]: LowerRisk,
        [RiskLevel.Increasing]: IncreasingRisk,
        [RiskLevel.Higher]: HigherRisk,
        [RiskLevel.High]: HighRisk
    },
    clinics: [
        {
            name: "Humankind PCRS",
            description: "Contact ${name}",
            location: { lat: 51.4372824, lng: -0.0565715 },
            address: "55 Dartmouth Road, Forest Hill, SE23 3HN",
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    times: {
                        monday: [{ start: 930, end: 1700 }],
                        tuesday: [{ start: 930, end: 1700 }],
                        wednesday: [{ start: 930, end: 1700 }],
                        thursday: [{ start: 930, end: 1700 }],
                        friday: [{ start: 930, end: 1700 }]
                    }
                }
            ],
            isPrimaryProvider: true,
            phone: ["02086995263"],
            website: "https://humankindcharity.org.uk/service/primary-care-recovery-service-pcrs"
        },
        {
            name: "Compass@THEHUB",
            tagline: "(Young Peoples Service)",
            email: "LHWS@Compass-uk.org",
            description: 'Contact ${name} on ${phone} or email <a href="mailto:${email}">${email}</a>. ' +
                "ChatHealth confidential text messaging on 07507 331 526",
            location: { lat: 51.4462668, lng: -0.0226541 },
            address: "38-39 Winslade way, Catford, London SE6 4JU",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1630 }]
                    }
                }
            ],
            phone: ["02086903020"],
            website: "https://www.compass-uk.org/services/lewisham-compassthehub/"
        },
        {
            name: "New Direction Drug and Alcohol Recovery Service (CGL)",
            description: "Contact CGL",
            location: { lat: 51.4516542, lng: -0.0194386 },
            address: "410 Lewisham High Street, London, SE13 6LJ",
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    times: {
                        monday: [{ start: 930, end: 1900 }],
                        tuesday: [{ start: 1330, end: 1700 }],
                        wednesday: [{ start: 930, end: 1900 }],
                        thursday: [{ start: 930, end: 1700 }],
                        friday: [{ start: 930, end: 1700 }],
                        saturday: [{ start: 930, end: 1630 }]
                    }
                }
            ],
            phone: ["02083145566"],
            website: "https://www.changegrowlive.org/new-direction-drug-alcohol-recovery-lewisham"
        },
        {
            name: "DrinkCoach Online Appointment",
            tagline: "Book a free appointment with an alcohol specialist.",
            alwaysShowInResults: true,
            website: "https://drinkcoach.org.uk/book-online-appointment",
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher]
        }
    ]
};
//# sourceMappingURL=Lewisham.js.map